// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4712":"aabb2b4c6c0cff20","5507":"f3491cb063c3a554","8159":"4dc2b4af0b3a541b"}[chunkId] + ".css";
};